import React from 'react';
import { Truck, Store, ShieldCheck, Sparkles } from 'lucide-react';

const badges = [
  {
    icon: Truck,
    title: 'Envío Express',
    description: 'Gratis desde $1,197',
  },
  {
    icon: Store,
    title: 'Paga en OXXO',
    description: 'Sin tarjeta necesaria',
  },
  {
    icon: ShieldCheck,
    title: 'Pago Seguro',
    description: 'Protegido por Stripe',
  },
  {
    icon: Sparkles,
    title: 'Garantía 15 Días',
    description: 'Cambio o devolución',
  }
];

// Estilos completos (no interpolados) por acento, para que Tailwind los detecte de forma confiable.
const ACCENT_STYLES = {
  cobalt: {
    border: 'hover:border-brand-cobalt/40',
    iconBg: 'bg-brand-cobalt/10 group-hover:bg-brand-cobalt/20',
    icon: 'text-brand-cobalt',
    text: 'text-brand-cobalt/70',
  },
  magenta: {
    border: 'hover:border-brand-magenta/40',
    iconBg: 'bg-brand-magenta/10 group-hover:bg-brand-magenta/20',
    icon: 'text-brand-magenta',
    text: 'text-brand-magenta/70',
  },
};

const ProductTrustBadges = ({ gender = 'Hombre' }) => {
  const isFemale = gender === 'Mujer';

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 pt-4">
      {badges.map((badge, index) => {
        const Icon = badge.icon;
        // Alternate colors: cobalto, magenta, cobalto, magenta
        const isEven = index % 2 === 0;
        const accentKey = isFemale
          ? (isEven ? 'magenta' : 'cobalt')
          : (isEven ? 'cobalt' : 'magenta');
        const accent = ACCENT_STYLES[accentKey];

        return (
          <div
            key={badge.title}
            className={`
              group relative p-3 rounded-xl text-center
              bg-brand-black/[0.02] border border-brand-black/10
              ${accent.border}
              hover:bg-brand-black/[0.04]
              transition-all duration-300
            `}
          >
            {/* Icon */}
            <div className={`
              w-10 h-10 mx-auto mb-2 rounded-full
              flex items-center justify-center
              ${accent.iconBg}
              transition-colors duration-300
            `}>
              <Icon
                size={18}
                className={`${accent.icon} group-hover:scale-110 transition-transform duration-300`}
              />
            </div>

            {/* Title */}
            <p className="text-brand-black font-semibold text-xs mb-0.5">
              {badge.title}
            </p>

            {/* Description */}
            <p className={`${accent.text} text-[10px]`}>
              {badge.description}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default ProductTrustBadges;
